module.exports = __webpack_public_path__ + "static/media/S1_00032.bd2908ee.jpg";